import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { PublicLayout } from "../components/layout";
import { tokenStorage } from "../utils/tokenStorage";

export const Route = createFileRoute("/_public")({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/" && tokenStorage.getAccessToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirect()
      throw redirect({ to: "/app" });
    }
  },
  component: () => (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ),
});
